// extracted by mini-css-extract-plugin
export default {"container":"zF-z","innerContainer":"AF-z","multipleLines":"BF-z","heading":"CF-z","content":"DF-z","linkColor":"EF-z"};